import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";

const actionTypes = {
  FETCH_MEMBER_ENQUIRY: "FETCH_MEMBER_ENQUIRY",
  RESET: "RESET",
};

const fetchReset = async (state) => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  };
  return state;
};
const fetchCardActivate = async (state, memberenquiry) => {
  state = {
    ...state,
    isStatus: memberenquiry.status,
    expireToken: sanitizeExpire({
      status: memberenquiry.status,
      data: memberenquiry.data,
      name: "memberenquiryobj",
    }),
    data: sanitizeData({
      status: memberenquiry.status,
      data: memberenquiry.data,
      name: "memberenquiryobj",
    }),
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MEMBER_ENQUIRY:
      return fetchCardActivate(state, action.memberenquiry);
    case actionTypes.RESET:
      return fetchReset(state);
    default:
      return state;
  }
};

const memberenquiry = {
  init,
  actionTypes,
  reducer,
};

export default memberenquiry;
